"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=proposal.model.js.map